/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Vakanties_Regio_KiezenInputs */

const nl_planning_vakanties_regio_kiezen = /** @type {(inputs: Planning_Vakanties_Regio_KiezenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een regio`)
};

/**

* @param {Planning_Vakanties_Regio_KiezenInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_regio_kiezen = /** @type {((inputs?: Planning_Vakanties_Regio_KiezenInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Regio_KiezenInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_regio_kiezen(inputs)
});
export { planning_vakanties_regio_kiezen as "planning.vakanties.regio_kiezen" }